import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import Modal from 'components/Modal';
import useTranslation from 'services/i18n/core/useTranslation';

interface NewMessageDialogProps {
  open: boolean;
  onClose: () => void;
  onSend: (message: string) => void;
  loading?: boolean;
  defaultValue?: string;
}

const NewMessageDialog: React.FC<NewMessageDialogProps> = ({ open, onClose, onSend, loading = false, defaultValue = '' }) => {
  const [message, setMessage] = useState(defaultValue);
  const translation = useTranslation();

  const handleSend = () => {
    if (message.trim()) {
      onSend(message.trim());
    }

  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={translation.COMMENT_REACT_TITLE}
      actions={
        <Button
          variant="contained"
          color="primary"
          onClick={handleSend}
          disabled={!message.trim() || loading}
          sx={{ borderRadius: '24px', minWidth: 120 }}
        >
          {translation.SEND}
        </Button>
      }
      contentClassname="flex column align-items-center"
    >
      <TextField
        autoFocus
        multiline
        minRows={5}
        maxRows={8}
        fullWidth
        placeholder={translation.MESSAGE}
        value={message}
        onChange={e => setMessage(e.target.value)}
        variant="outlined"
        sx={{
          background: '#fafafa',
          borderRadius: '12px',
          mb: 2,
          mt: 1,
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
          },
        }}
        inputProps={{ maxLength: 1000 }}
        disabled={loading}
      />
      <Typography variant="caption" color="textSecondary" sx={{ mb: 2 }}>
        {translation.COMMENT_REACT_DESC}
      </Typography>
    </Modal>
  );
};

export default NewMessageDialog;
